import { applyMiddleware, createStore } from "redux"
import thunk from "redux-thunk"
import reduxImmutableStateInvariant from "redux-immutable-state-invariant"
import axios from "axios"
import axiosMiddleware from "redux-axios-middleware"
import rootReducer from "../reducers"
import { ENVIRONMENT } from "../../constants"

/** Creates a new Redux store for this app, configured how we want it */
export default function configureStore(initialState) {
  // Configure access to the API via Axios
  const apiClient = axios.create({
    baseURL: ENVIRONMENT.getApiRootUrl(),
    responseType: "json",
  })

  const axiosMiddlewareOptions = {
    interceptors: {
      request: [
        (state, config) => {
          const configCopy = config
          if (state.getState().oidc.user.access_token) {
            configCopy.headers.Authorization = `Bearer ${state.getState().oidc.user.access_token}`
          }
          return configCopy
        },
      ],
    },
  }

  return createStore(
    rootReducer,
    initialState,
    applyMiddleware(
      reduxImmutableStateInvariant(),
      thunk,
      axiosMiddleware(apiClient, axiosMiddlewareOptions)
    )
  )
}



// WEBPACK FOOTER //
// ./src/state/store/configureStore.js